var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightConnectorPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "130px",
    viewBox: "0 0 12 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30D9DCA8-6979-4B03-944E-8505A89B862E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM_Flightcards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Flightcards_Mobile_withdates",
    transform: "translate(-1537, -714)",
    stroke: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Flightcard/Mobile/Dates/Direct/UnselectedDetails",
    transform: "translate(1521, 240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flightconnector/Vertical/XLarge/Transfer",
    transform: "translate(16, 474)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -55,
    y1: 65,
    x2: 67,
    y2: 65,
    id: "Path",
    strokeWidth: 2,
    transform: "translate(6, 65) rotate(90) translate(-6, -65)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(6, 6) rotate(90) translate(-6, -6)",
    cx: 6,
    cy: 6,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    transform: "translate(6, 124) rotate(90) translate(-6, -124)",
    cx: 6,
    cy: 124,
    r: 5.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightConnectorPayment);
export default __webpack_public_path__ + "static/media/flight-connector-payment.f9483347b3955d8a5c910eedf9834231.svg";
export { ForwardRef as ReactComponent };